import CurrencyAdjustAmount from './CurrencyAdjustAmount';
export default CurrencyAdjustAmount;
//# sourceMappingURL=index.js.map
